import { PositionLogger } from "./positionLogger";
import { ENVIRONMENT } from "../../constants";
import { PositionLoggingAPI, UUID } from "./positionLoggingAPI";
import { PositionLoggingGeolocationProvider } from "./positionLoggingGeolocationProvider";

let positionLoggingAPI: PositionLoggingAPI;

interface PositionLogging {
  positionLogger: PositionLogger | null;
  positionLoggingGeolocationProvider: PositionLoggingGeolocationProvider | null;
}

const positionLogging: PositionLogging = {
  positionLogger: null,
  positionLoggingGeolocationProvider: null,
};

export function initialisePositionLogging(
  project: string,
  positionLoggingEnabled: boolean, // position recording mode
  positionLoggingSessionUUID: UUID | null, // position playback mode
): PositionLogging {
  if (
    !positionLoggingAPI &&
    (positionLoggingEnabled || positionLoggingSessionUUID)
  ) {
    const host = `https://position-logging-api.${ENVIRONMENT}.livingmap.com`;
    positionLoggingAPI = new PositionLoggingAPI(host);
  }

  if (
    positionLoggingEnabled &&
    !positionLoggingSessionUUID &&
    !positionLogging.positionLogger
  ) {
    positionLogging.positionLogger = new PositionLogger(
      project,
      positionLoggingAPI,
    );
  }

  if (
    positionLoggingSessionUUID &&
    !positionLoggingEnabled &&
    !positionLogging.positionLoggingGeolocationProvider
  ) {
    positionLogging.positionLoggingGeolocationProvider =
      new PositionLoggingGeolocationProvider(
        positionLoggingAPI,
        positionLoggingSessionUUID,
      );
  }

  return positionLogging;
}
